module.exports = __webpack_public_path__ + "img/icon_07.cf976795.png";